import { render, staticRenderFns } from "./StaffPageTable.vue?vue&type=template&id=5821dc6a&scoped=true&"
import script from "./StaffPageTable.vue?vue&type=script&lang=js&"
export * from "./StaffPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821dc6a",
  null
  
)

export default component.exports